var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import HeaderImagePositioner from '../screens/_shared/components/header-image-positioner';
import { create as createAttachment, softDelete, setHeaderVariant } from '../common/network/attachment';
import { isImage } from '../types';
import { useToast } from '../contexts/toast';
export const useHeaderPositioner = ({ value, onChange }) => {
    var _a, _b;
    const toast = useToast();
    const [positioningId, setPositioningId] = React.useState(null);
    const images = value ? value.attachments.filter(isImage) : [];
    const positioningPhoto = images.find(p => p.id === positioningId);
    const positioningHeader = (positioningPhoto === null || positioningPhoto === void 0 ? void 0 : positioningPhoto.assetId) && value
        ? value.headerVariants.find(h => h.assetId === positioningPhoto.assetId)
        : undefined;
    const mainPhoto = (_a = images.find(p => p.isMain)) !== null && _a !== void 0 ? _a : null;
    const handleSave = (assetId, file) => __awaiter(void 0, void 0, void 0, function* () {
        if (assetId && value) {
            const [ok, results] = yield createAttachment('property', [file], 0);
            if (ok) {
                const [linked, headerAtt] = yield setHeaderVariant(assetId, results[0].id);
                if (linked) {
                    onChange(Object.assign(Object.assign({}, value), { headerVariants: [...value.headerVariants.filter(h => h.assetId !== assetId), headerAtt] }));
                    toast.success('Header position saved');
                }
            }
        }
        setPositioningId(null);
    });
    const handleReset = () => __awaiter(void 0, void 0, void 0, function* () {
        if (positioningHeader && value) {
            const [ok] = yield softDelete(positioningHeader);
            if (ok) {
                onChange(Object.assign(Object.assign({}, value), { headerVariants: value.headerVariants.filter(h => h.id !== positioningHeader.id) }));
                toast.success('Header positioning removed');
            }
        }
        setPositioningId(null);
    });
    const element = positioningPhoto && positioningPhoto.assetId ? (_jsx(HeaderImagePositioner, { imageUrl: `/api/attachments/${positioningPhoto.id}/raw`, isOpen: positioningId !== null, hasHeader: !!positioningHeader, onClose: () => setPositioningId(null), onSave: (file) => handleSave(positioningPhoto.assetId, file), onReset: handleReset })) : null;
    const mainPhotoId = (_b = mainPhoto === null || mainPhoto === void 0 ? void 0 : mainPhoto.id) !== null && _b !== void 0 ? _b : null;
    const openForMain = React.useCallback(() => {
        if (mainPhotoId)
            setPositioningId(mainPhotoId);
    }, [mainPhotoId]);
    return {
        openFor: setPositioningId,
        openForMain,
        canAdjustMain: !!(mainPhoto === null || mainPhoto === void 0 ? void 0 : mainPhoto.assetId),
        element,
    };
};
